export class PaginationObject {
  count: number = 0;
  limit: number = 10;
  offset: number = 0;
  pageSize: number = 10;
}
